jQuery( document ).ready(function() {
  let $ = jQuery;
  var $status = $('.slide-count');
  var $slickElement = $('.gallery-slider .slider');

  $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + '/' + slick.slideCount);
  });
  if( jQuery('section.gallery-slider').length ) {
    $slickElement.slick({
      centerMode: true,
      centerPadding: '20vw',
      slidesToShow: 1,
      infinite: true,
      arrows: true,
      rows: 0,
      autoplay: false,
      autoplaySpeed: 5000,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1
            }
        },
      ]
    });
  }
});